import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers/index';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'edge-support-header',
  templateUrl: './support-header.component.html',
  styleUrls: ['./support-header.component.scss']
})
export class SupportHeaderComponent {
  sport$: Observable<string> = this.store.select(fromRoot.getSport);
  environment = environment;

  constructor(private store: Store<fromRoot.State>) {}
}
